import { useMemo } from "react";
import store from "store";

import { AccountEnum } from "store/balances";

const Main = () => {
  const { leverConfigAry, futuresUsdtTransferList, futuresCoinTransferList } = store.market;
  const { currencies, currencyObj } = store.currency;

  const allAccCurrencyObj = useMemo(() => {
    const spot = currencies ? currencies.filter((obj) => obj.transferEnabled) : [];
    const lever = (() => {
      if (!currencyObj || !leverConfigAry) return [];
      const aryTemp: string[] = [];
      const aryRet: { currency: string }[] = [];
      leverConfigAry.map((doc) => {
        const ary = doc.marketName.split("_");
        let coin;
        for (let i = 0; i < ary.length; i++) {
          coin = ary[i];
          if (!aryTemp.includes(coin) && currencyObj[coin] && currencyObj[coin].transferEnabled) {
            aryRet.push({ currency: coin });
            aryTemp.push(coin);
          }
        }
      });
      return aryRet;
    })();
    const futures_u = (() => {
      if (!currencyObj || !futuresUsdtTransferList) return [];
      const aryRet: { currency: string }[] = [];
      futuresUsdtTransferList.map((currency) => {
        const obj = currencyObj[currency];
        if (obj && obj.transferEnabled) {
          aryRet.push(obj);
        }
      });
      return aryRet;
    })();
    const futures_c = (() => {
      if (!currencyObj || !futuresCoinTransferList) return [];
      const aryRet: { currency: string }[] = [];
      futuresCoinTransferList.map((currency) => {
        const obj = currencyObj[currency];
        if (obj && obj.transferEnabled) {
          aryRet.push(obj);
        }
      });
      return aryRet;
    })();

    return {
      [AccountEnum.spot]: spot,
      [AccountEnum.lever]: lever,
      // [AccountEnum.finance]: spot,
      [AccountEnum.futures_u]: futures_u,
      [AccountEnum.futures_c]: futures_c,
    };
  }, [currencies, currencyObj, leverConfigAry, futuresUsdtTransferList, futuresCoinTransferList]);

  return allAccCurrencyObj;
};

export default Main;
